export interface SEOScores {
  localSEO: number;
  technicalSEO: number;
  contentOptimization: number;
}

export interface SEOResult {
  questionId: number;
  selectedOption: number;
  scores: SEOScores;
}

export interface Question {
  id: number;
  question: string;
  options: {
    text: string;
    scores: SEOScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    question: "How often do potential customers find your business through local Google searches?",
    options: [
      {
        text: "Frequently - we appear in top local search results",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Sometimes - we show up but not consistently",
        scores: { localSEO: 2, technicalSEO: 2, contentOptimization: 1 }
      },
      {
        text: "Rarely - customers struggle to find us online",
        scores: { localSEO: 3, technicalSEO: 2, contentOptimization: 2 }
      },
      {
        text: "Never - we don't appear in local search results",
        scores: { localSEO: 3, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 2,
    question: "Is your Google Business Profile fully optimized with Saskatchewan-specific information?",
    options: [
      {
        text: "Yes - complete with local keywords, photos, and regular updates",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Partially - we have a profile but it's not regularly maintained",
        scores: { localSEO: 2, technicalSEO: 1, contentOptimization: 2 }
      },
      {
        text: "Minimal - basic information only, rarely updated",
        scores: { localSEO: 3, technicalSEO: 2, contentOptimization: 3 }
      },
      {
        text: "No - we don't have a Google Business Profile or it's incomplete",
        scores: { localSEO: 3, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 3,
    question: "How well does your website perform on mobile devices for search rankings?",
    options: [
      {
        text: "Excellent - mobile-optimized with fast loading and good user experience",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Good - works on mobile but could be faster or more responsive",
        scores: { localSEO: 1, technicalSEO: 2, contentOptimization: 1 }
      },
      {
        text: "Poor - slow loading, difficult navigation on mobile devices",
        scores: { localSEO: 2, technicalSEO: 3, contentOptimization: 2 }
      },
      {
        text: "Unknown - we haven't tested mobile performance or SEO impact",
        scores: { localSEO: 2, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 4,
    question: "Does your website content include relevant Saskatchewan and local keywords?",
    options: [
      {
        text: "Yes - strategically optimized with local keywords throughout",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Somewhat - we mention our location but not strategically",
        scores: { localSEO: 2, technicalSEO: 1, contentOptimization: 2 }
      },
      {
        text: "Minimal - very few local keywords or geographic references",
        scores: { localSEO: 3, technicalSEO: 2, contentOptimization: 3 }
      },
      {
        text: "No - our content is generic without local optimization",
        scores: { localSEO: 3, technicalSEO: 2, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 5,
    question: "How often do you publish fresh, relevant content that targets your Saskatchewan audience?",
    options: [
      {
        text: "Regularly - weekly or monthly updates with local relevance",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Occasionally - a few times per year when we have time",
        scores: { localSEO: 2, technicalSEO: 1, contentOptimization: 2 }
      },
      {
        text: "Rarely - our website content is mostly outdated",
        scores: { localSEO: 2, technicalSEO: 2, contentOptimization: 3 }
      },
      {
        text: "Never - we haven't updated content since launch",
        scores: { localSEO: 3, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 6,
    question: "Are you tracking your website's search rankings and organic traffic performance?",
    options: [
      {
        text: "Yes - we actively monitor rankings, traffic, and conversions",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Sometimes - we check occasionally but don't track consistently",
        scores: { localSEO: 2, technicalSEO: 2, contentOptimization: 2 }
      },
      {
        text: "Rarely - we look at analytics but don't focus on SEO metrics",
        scores: { localSEO: 2, technicalSEO: 3, contentOptimization: 2 }
      },
      {
        text: "No - we don't track search performance or organic traffic",
        scores: { localSEO: 3, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  },
  {
    id: 7,
    question: "Do you have quality backlinks from other Saskatchewan businesses or local organizations?",
    options: [
      {
        text: "Yes - strong local backlink profile from reputable sources",
        scores: { localSEO: 1, technicalSEO: 1, contentOptimization: 1 }
      },
      {
        text: "Some - a few local links but not many",
        scores: { localSEO: 2, technicalSEO: 1, contentOptimization: 2 }
      },
      {
        text: "Minimal - very few or no local backlinks",
        scores: { localSEO: 3, technicalSEO: 2, contentOptimization: 2 }
      },
      {
        text: "Unknown - we've never worked on building local backlinks",
        scores: { localSEO: 3, technicalSEO: 3, contentOptimization: 3 }
      }
    ]
  }
];
